import React, { useState } from "react";

function App() {
  const [baseImage, setBaseImage] = useState("");
  const [imageUrl, setImageUrl] = useState("");

 // Example proxy
  const fetchImageFromUrl = async () => {
    try {
      const response = await fetch(`${imageUrl}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const blob = await response.blob();
      const base64 = await convertBase64(blob);
      setBaseImage(base64);
    } catch (error) {
      console.error("Error fetching image from URL:", error);
    }
  };

  const convertBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(blob);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  return (
    <div className="App">
      <h3>Upload Image or Enter Image URL</h3>
      {/* Input for Image URL */}
      <input
        type="text"
        placeholder="Enter Image URL"
        value={imageUrl}
        onChange={(e) => setImageUrl(e.target.value)}
        style={{ width: "300px", marginRight: "10px" }}
      />
      <button onClick={fetchImageFromUrl}>Fetch Image</button>
      <br />
      <br />
      {/* Display Base64 Image */}
      {baseImage && (
        <>
          <img src={baseImage} alt="Uploaded" height="200px" />
          <br />
          <textarea
            value={baseImage}
            readOnly
            rows="10"
            cols="50"
            style={{ marginTop: "10px" }}
          />
        </>
      )}
    </div>
  );
}

export default App;